import { render, staticRenderFns } from "./SharedContacts.vue?vue&type=template&id=9e095ca6"
import script from "./SharedContacts.vue?vue&type=script&lang=js"
export * from "./SharedContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports